const icons = `<!--begin::Svg Icon | path: icons/duotune/general/gen036.svg-->
<span class="svg-icon toggle-on svg-icon-primary svg-icon-1">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
        <rect x="6.0104" y="10.9247" width="12" height="2" rx="1" fill="black" />
    </svg>
</span>
<!--end::Svg Icon-->
<!--begin::Svg Icon | path: icons/duotune/general/gen035.svg-->
<span class="svg-icon toggle-off svg-icon-1">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
        <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
        <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
    </svg>
</span>
<!--end::Svg Icon-->`;

const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <div class="card card-flush w-100 bgi-position-x-end bgi-position-y-center mb-6 px-20" style="height:246px;background-image:url('assets/media/misc/bg_faq.png');">
            <div class="d-flex h-100 align-items-center">
                <div class="card-title">
                    <h1 class="fs-2hx text-white teko-header" data-i18n="faq.title">Support Center</h1>
                    <p class="text-gray-700 fs-6"  data-i18n="faq.subtitle">Find the answer for any question</p>
                </div>
            </div>            
        </div>
        <!--begin::FAQ card-->
        <div class="card">
            <!--begin::Body-->
            <div class="card-body p-lg-15">
                <!--begin::Layout-->
                <div class="d-flex flex-column flex-lg-row">
                    <!--begin::Sidebar-->
                    <div class="flex-column flex-lg-row-auto w-100 w-lg-275px mb-10 me-lg-20">
                        <!--begin::Catigories-->
                        <div class="mb-15">
                            <h4 class="text-white mb-7 text-uppercase teko-header" data-i18n="faq.sections">Support Sections</h4>
                            
                            <ul class="nav nav-tabs nav-pills flex-row border-0 flex-md-column me-5 mb-3 mb-md-0 fs-6 min-w-lg-200px" role="tablist">
                                <li class="nav-item w-100 me-0 mb-md-2" role="presentation">
                                    <span class="w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-success border-hover-success btn-active-light-success btn-active-color-success active" data-bs-toggle="tab" data-bs-target="#faq-anticheat" aria-selected="true" role="tab">
                                        <i class="fad fa-shield fs-2x pe-0 me-3"></i>
                                        <span class="d-flex flex-column align-items-start">
                                            <span class="ffs-4 fw-bold text-white" data-i18n="faq.ac">Akros Anticheat</span>
                                            <span class="fs-7 fw-bold text-gray-700 text-start" data-i18n="faq.ac_sub">Common issues</span>
                                        </span>
                                    </span>
                                </li>
                                
                            </ul>
                        </div>
                        <!--end::Catigories-->
                        
                    </div>
                    <!--end::Sidebar-->

                    <!--begin::Content-->                    
                    <div class="flex-lg-row-fluid">
                        <div class="tab-content">
                            <!--begin::Tabpane-->
                            <div class="tab-pane fade show active" id="faq-anticheat" data-i18n="[html]faq.ac_content" role="tabpanel">
                                
                            </div>
                        </div>
                    </div>
                    <!--end::Content-->
                </div>
                <!--end::Layout-->
                
            </div>
            <!--end::Body-->
        </div>
        <!--end::FAQ card-->
    </div>
    <!--end::Container-->

`;


export default view;